<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_search_placeholder') ||
                  '样品款号/样品条码/名称/客户 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <el-badge
              :value="checkedCount"
              :hidden="!checkedCount"
              class="printer-button"
              :class="{ clearable: !!checkedCount }"
            >
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                :class="{ clearable: !!checkedCount }"
                @click="exportData()"
                v-if="allow('E')"
              >
                {{ $l('INDEX.btn_export') || '导出' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="680px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sample_style_no') || '样品款号'"
            >
              <el-input
                v-model="form.sampleStyleNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_input_code') || '样品条码'">
              <el-input
                v-model="form.inputCode"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sample_name_en') || '英文品名'"
            >
              <el-input
                v-model="form.sampleNameEn"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_sample_name') || '样品名称'">
              <el-input
                v-model="form.sampleName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customer') || '客户'">
              <dict-select
                clearable
                v-model="form.useCustCode"
                filterable
                url="/master/common/dict/customerSelect"
                :placeholder="$l('tips_select_customer') || '请选择客户'"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_factory') || '收货工厂'">
              <dict-select
                clearable
                size="small"
                filterable
                v-model="form.useFactoryCode"
                :placeholder="$l('tips_select_factory') || '请选择工厂'"
                url="/master/common/dict/scmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_sales') || '申请人名称'">
              <dict-select
                clearable
                v-model="form.useSalesCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('tips_select_sales') || '请选择申请人名称'"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_use_place') || '使用地点'"
              prop="usePlace"
            >
              <dict-select
                :placeholder="$l('tips_select_use_place') || '请输入使用地点'"
                size="small"
                clearable
                filterable
                v-model="form.usePlace"
                :body="{ dictType: 'usePlace' }"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
              <el-form-item :label="$l('form_label_createBy') || '创建人名称'">
                <dict-select
                  clearable
                  v-model="form.createBy"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('tips_select_createBy') || '请选择创建人名称'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="this.$l('form_label_borrow_date') || '外借日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.borrowDateStart"
                    type="date"
                    :picker-options="dateStartPicker"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.borrowDateEnd"
                    :picker-options="dateEndPicker"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  productLine: '',
  masterCategoryCode: '',
  categoryCode: '',
}
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      form: { ...initForm },
      advqueryDialogVisible: false,
      dateStartPicker: this.dateEnd(),
      dateEndPicker: this.dateStart(),
    }
  },

  activated() {
    this.query()
  },

  methods: {
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 初始查询
    query() {
      this.$emit('query', this.form)
    },
    clearCheckboxRow() {
      this.$emit('clearCheckboxRow')
    },
    dateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.borrowDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.borrowDateEnd).getTime() < time.getTime()
          }
        },
      }
    },
    dateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.borrowDateStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.borrowDateStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    exportData() {
      this.$emit('exportData', this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
.printer-button {
  .el-icon-circle-close {
    display: none;
  }
}
.printer-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
